export default __webpack_public_path__ + "1767d6d550b3b8bdcf7944fdf951f736.svg";